// Auto-import SASS generated CSS
import './index.css';

export type {CloseButtonProps} from './CloseButton';
export {default as default} from './CloseButton';
